import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Unknown address while signed in (signed-out visitors go to the login page). */
const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const triedPath = useMemo(
    () => [location.pathname, location.search, location.hash].filter(Boolean).join(""),
    [location],
  );

  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/", { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 pt-14 md:pt-0">
      <div className="max-w-[560px] text-center">
        <p className="m-0 text-[13px] font-medium tracking-[0.18em] text-primary uppercase">Error 404</p>
        <h1 className="mt-3 mb-0 text-[clamp(2rem,4.2vw,3.2rem)] leading-[1.08] font-semibold text-foreground">
          This page took a wrong turn
        </h1>
        <p className="mx-auto mt-5 mb-0 max-w-[440px] text-base leading-relaxed text-muted-foreground">
          The address does not exist, or the page has moved.
        </p>
        {triedPath && (
          <p className="mt-4 mb-0 text-sm text-muted-foreground">
            <code className="rounded-full bg-secondary px-3 py-1 text-foreground">{triedPath}</code>
          </p>
        )}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button size="lg" className="px-5" onClick={() => navigate("/")}>
            Go to your start page
            <ArrowUpRight data-icon="inline-end" />
          </Button>
          <Button size="lg" variant="outline" className="px-5" onClick={goBack}>
            <ArrowLeft data-icon="inline-start" />
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
